import request from '@/helpers/request'
import config from '@/config'
import * as Sentry from '@sentry/browser'
import { FUNNEL_SOURCES } from '@/helpers/constants'

export default {
	namespaced: true,
	state: {
		stateHydrated: false,
		// {boolean} Enable credit card on paywall (via stripe)
		creditCard: true,
		// {boolean} Enable the whole paywall, after email redirected straight to Download page
		paywall: true,
		// {boolean} Enable paypal on payval (via braintree)
		paypal: true,
		// {boolean} Enable Apple Pay via braintree on paywall
		applePayBraintree: true,
		// {boolean} Enable Apple Pay via stripe on paywall
		applePayStripe: true,
		// {boolean} Enable Google Pay via stripe on paywall
		googlePay: true,
		// {{ [stripe|braintree|palta]: number }} Delay for /survey/account page (key - payment provider, value - delay in ms)
		accountPageDelay: {},
		// {{ [main|nofasting]: 'legacy' | 'strapi' }} Funnel sources for main and nofasting funnels
		funnelSources: {
			main: FUNNEL_SOURCES.STRAPI,
			nofasting: FUNNEL_SOURCES.STRAPI
		},
		// {('none'|'console'|'emit'|'both')} Log level for billing
		billingLogLevel: 'none',
		amplitude: {
			blackList: [],
			whiteList: []
		},
		palta: {
			blackList: [],
			whiteList: []
		}
	},
	getters: {
		FEAT_CREDIT_CARD_ENABLED(state) {
			return state.creditCard
		},
		FEAT_PAYWALL_ENABLED(state) {
			return state.paywall
		},
		FEAT_PAYPAL_ENABLED(state) {
			return state.paypal
		},
		FEAT_APPLEPAY_BRAINTREE_ENABLED(state) {
			return state.applePayBraintree
		},
		FEAT_APPLEPAY_STRIPE_ENABLED(state) {
			return state.applePayStripe
		},
		FEAT_GOOGLEPAY_ENABLED(state) {
			return state.googlePay
		},
		FEAT_ACCOUNT_PAGE_DELAY(state) {
			return state.accountPageDelay
		},
		FEAT_FUNNEL_SOURCES(state) {
			return state.funnelSources
		},
		FEAT_BILLING_LOG_LEVEL(state) {
			return state.billingLogLevel
		},
		FEAT_AMPLITUDE_WHITE_LIST(state) {
			return state.amplitude?.whiteList ?? []
		},
		FEAT_AMPLITUDE_BLACK_LIST(state) {
			return state.amplitude?.blackList ?? []
		},
		FEAT_PALTA_WHITE_LIST(state) {
			return state.palta?.whiteList ?? []
		},
		FEAT_PALTA_BLACK_LIST(state) {
			return state.palta?.blackList ?? []
		}
	},
	mutations: {
		setFeatureValue(state, payload) {
			state[payload.feature] = payload.value
		},
		setStateHydrated(state, payload) {
			state.stateHydrated = payload
		}
	},
	actions: {
		async hydrateCoreFeatures({ state, commit }) {
			if (state.stateHydrated) {
				return
			}
			try {
				const response = await request(config('FeatureFlagsUrl'))

				Object.entries(response).forEach(([feature, value]) => commit('setFeatureValue', { feature, value }))
			} catch (error) {
				Sentry.withScope((scope) => {
					scope.setTags({
						coreFeatures: true
					})
					Sentry.captureException(error)
				})
			} finally {
				commit('setStateHydrated', true)
				commit('status/setResourceReadiness', 'coreFeatures', { root: true })
			}
		}
	}
}
